// extracted by mini-css-extract-plugin
export default {"privacy":"Privacy_privacy__k5wqw","header":"Privacy_header__8Pz2h","title":"Privacy_title__iRraM"};